import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(
  () => import("../../components/settings/lookup/main")
);

const LookUp = () => {
  return (
    <Suspense fallback={<CircularLoader />}>
      <Main />
    </Suspense>
  );
};

export default LookUp;
